function commaNumber(number, decimal = 2){
    return number?.toLocaleString('en-US', { minimumFractionDigits : decimal, maximumFractionDigits : decimal, });
}

export default {
    commaNumber,
}